import { IInscriptionLieuExamenInformationsSession } from "./IInscriptionLieuExamenInformations.model";

export enum StatutInscription {
  INSCRIPTION_EN_ATTENTE = 'INSCRIPTION_EN_ATTENTE',
  INSCRIPTION_COMPLETEE = 'INSCRIPTION_COMPLETEE',
  INSCRIPTION_TERMINEE = 'INSCRIPTION_TERMINEE'
}

export default interface ISessionDossierExamen {
  abreviation: string;
  annee: number;
  codeSession: string;
  dateDebut: string;
  dateLimiteInscriptionLieuExamen: string;
  saison: string;
  token: string;
}

export default interface IDossierEtudiant {
  etudiant: {
    prenom: string;
    nom: string;
    nie: number;
  };
  horodateDerniereModification: string | null;
  afficherMessageMaterielPermis: boolean;
  afficherMessageCarteIdentite: boolean;
  statutInscription: StatutInscription;
  session: IInscriptionLieuExamenInformationsSession;
  afficherMessageContact: boolean;
  addresseContactAgente: string;
  sessionsDossierExamen: Array<ISessionDossierExamen>;
  gestionFicheRepondantDisponible: boolean;
}